import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import EntityTypes from '../../types/EntityTypes';
import data from 'emoji-mart/data/apple.json';
import { buildEmojiSearch, buildEmojiList, getEmojiNativeText } from '../utils/emojis';
import { scanUntilColon, getSearchText } from '../utils/getSearchText';
import insertEntity from '../utils/insertEntity'; // Constants

var emojiSearch = buildEmojiSearch();
export var defaultState = {
  isVisible: false,
  index: -1,
  search: emojiSearch,
  items: buildEmojiList('', emojiSearch),
  itemsPerRow: 7,
  searchWord: null,
  notFoundEmoji: data.emojis.thinking_face,
  placeholderEmoji: data.emojis.point_up,
  selectedViaKeyboard: false
}; // Selectors

export function canCommit(state) {
  return state.isVisible && state.index > -1 && state.items.length > 0;
}
export function canOpen(value) {
  var selection = value.selection,
      startText = value.startText;
  var text = startText.text;
  var start = selection.start;
  var string = text.slice(0, start.offset);
  return scanUntilColon.test(string);
}
export function canSearch(value) {
  var _getSearchText = getSearchText(scanUntilColon, value),
      searchWord = _getSearchText.searchWord;

  return searchWord.startsWith(':');
} // Reducers

export function moveUp() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;

  if (!canCommit(state)) {
    return defaultState;
  }

  var updatedIndex = state.index - state.itemsPerRow;

  if (updatedIndex < 0) {
    return state;
  }

  return _objectSpread({}, state, {
    selectedViaKeyboard: true,
    index: updatedIndex
  });
}
export function moveDown() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var updatedIndex = state.index === -1 ? 0 : state.index + state.itemsPerRow;

  if (updatedIndex > state.items.length) {
    return state;
  }

  return _objectSpread({}, state, {
    selectedViaKeyboard: true,
    index: updatedIndex
  });
}
export function moveLeft() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var updatedIndex = state.index - 1;

  if (updatedIndex < 0) {
    return state;
  }

  return _objectSpread({}, state, {
    selectedViaKeyboard: true,
    index: updatedIndex
  });
}
export function moveRight() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var updatedIndex = state.index + 1;

  if (updatedIndex >= state.items.length) {
    return state;
  }

  return _objectSpread({}, state, {
    selectedViaKeyboard: true,
    index: updatedIndex
  });
}
export function select() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      index = _ref.index;

  return _objectSpread({}, state, {
    selectedViaKeyboard: false,
    index: index
  });
}
export function open(state, _ref2) {
  var value = _ref2.value;

  if (!canOpen(value)) {
    return defaultState;
  }

  return _objectSpread({}, defaultState, {
    isVisible: true
  });
}
export function close() {
  return _objectSpread({}, defaultState, {
    isVisible: false
  });
}
export function search() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;

  var _ref3 = arguments.length > 1 ? arguments[1] : undefined,
      value = _ref3.value;

  if (!canSearch(value)) {
    return defaultState;
  }

  var _getSearchText2 = getSearchText(scanUntilColon, value),
      searchWord = _getSearchText2.searchWord;

  var isVisible = searchWord.startsWith(':');
  var searchToken = searchWord.slice(1).toLowerCase();
  return _objectSpread({}, state, {
    index: searchToken.length === 0 ? -1 : 0,
    isVisible: isVisible,
    searchWord: searchToken,
    items: buildEmojiList(searchToken, emojiSearch)
  });
}
export function commit() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;

  var _ref4 = arguments.length > 1 ? arguments[1] : undefined,
      emoji = _ref4.emoji,
      index = _ref4.index,
      editor = _ref4.editor;

  var items = state.items;
  var selectedEmoji = emoji || items[index];
  var emojiText = getEmojiNativeText(selectedEmoji);
  insertEntity(editor, scanUntilColon, emojiText, EntityTypes.EMOJI, {
    emojiId: emojiText,
    emojiColon: selectedEmoji.id
  }).insertText(' ');
  return defaultState;
} // Key handlers

export function arrowKeyHandler(event, value, store, arrowHandler) {
  var _ref5 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
      _ref5$keyForFirstInte = _ref5.keyForFirstInteraction,
      keyForFirstInteraction = _ref5$keyForFirstInte === void 0 ? false : _ref5$keyForFirstInte;

  var state = store.getItem('state');

  if (!keyForFirstInteraction && !canCommit(state)) {
    return undefined;
  }

  if (state.isVisible) {
    event.preventDefault();
    store.updateItem('state', arrowHandler(state));
    return true;
  }

  return undefined;
}
export function commitKeyHandler(event, editor, store) {
  if (canCommit(store.getItem('state'))) {
    event.preventDefault();
    var state = store.getItem('state');
    var emoji = state.emoji,
        index = state.index;
    store.updateItem('state', commit(state, {
      editor: editor,
      emoji: emoji,
      index: index
    }));
    return true;
  }

  return undefined;
}